module.exports = "/_next/static/resources/couple-5198f670f07e46d691e34ea52cc8a492.jpg";